var breakpoints = {
    small: 320,
    medium: 600,
    large: 1136,
};
export default breakpoints;
